import React from 'react'
import UserPosters from './components/UserPosters/UserPosters'

const App = () => {
  return <UserPosters />
}

export default App